export enum LTA_TYPES {
  INSPECTION = 'INSPECTION'
}